/**
 * Affichage cohérent prix pro : PU HT + référence publique HT barrée (comparaison HT / HT).
 */

export function vatFactor(vatPct) {
  return 1 + Math.max(0, Number(vatPct) || 20) / 100;
}

export function ttcToHt(ttc, vatPct = 20) {
  if (ttc == null || Number.isNaN(Number(ttc))) return null;
  const f = vatFactor(vatPct);
  return Math.round((Number(ttc) / f) * 100) / 100;
}

/**
 * TTC vitrine à barrer pour un pro : max(prix public catalogue, prix avant promo visible).
 */
export function strikePublicTtc(resolved, catalogPriceTtc) {
  if (!resolved) return null;
  const resolvedTtc = Number(resolved.price);
  if (Number.isNaN(resolvedTtc)) return null;
  const refPub =
    resolved.reference_public_ttc != null && !Number.isNaN(Number(resolved.reference_public_ttc))
      ? Number(resolved.reference_public_ttc)
      : catalogPriceTtc != null && !Number.isNaN(Number(catalogPriceTtc))
        ? Number(catalogPriceTtc)
        : null;
  const beforePromo =
    resolved.has_visible_promo && resolved.price_before_visible_promo != null
      ? Number(resolved.price_before_visible_promo)
      : null;
  let strike = null;
  if (refPub != null && refPub > resolvedTtc + 0.001) strike = refPub;
  if (beforePromo != null && beforePromo > resolvedTtc + 0.001) {
    if (strike == null || beforePromo > strike) strike = beforePromo;
  }
  return strike;
}

/** Même référence que strikePublicTtc, exprimée en HT (pour affichage pro). */
export function strikePublicHt(resolved, catalogPriceTtc) {
  const ttc = strikePublicTtc(resolved, catalogPriceTtc);
  if (ttc == null) return null;
  const vat = resolved?.vat_rate ?? 20;
  return ttcToHt(ttc, vat);
}

/** Prix unitaire HT pour affichage pro (priorité au champ moteur). */
/** Lignes commande / devis (API order & quote items) — base HT cohérente pour espace client pro. */
export function orderAccountItemVat(item) {
  const v = Number(item?.vat_rate);
  return Number.isFinite(v) && v > 0 ? v : 20;
}

export function orderAccountUnitTtc(item) {
  return Number(item?.unit_price ?? item?.price ?? 0);
}

export function orderAccountUnitHt(item) {
  if (item?.unit_price_ht != null && !Number.isNaN(Number(item.unit_price_ht))) return Number(item.unit_price_ht);
  const ut = orderAccountUnitTtc(item);
  if (!ut) return 0;
  return ttcToHt(ut, orderAccountItemVat(item));
}

export function orderAccountLineHt(item) {
  if (item?.line_total_ht != null && !Number.isNaN(Number(item.line_total_ht))) return Number(item.line_total_ht);
  const q = Number(item?.quantity) || 0;
  return Math.round(orderAccountUnitHt(item) * q * 100) / 100;
}

export function orderAccountLineTtc(item) {
  const up = orderAccountUnitTtc(item);
  const q = Number(item?.quantity) || 0;
  return Number(item?.line_total ?? q * up);
}

/** Référence publique HT barrée (ligne panier / mini-panier) à partir des champs API. */
export function strikePublicHtFromCartItem(item) {
  const resolved = {
    price: orderAccountUnitTtc(item),
    reference_public_ttc: item.reference_public_ttc != null ? Number(item.reference_public_ttc) : undefined,
    has_visible_promo: item.has_visible_promo,
    price_before_visible_promo: item.price_before_visible_promo,
    vat_rate: orderAccountItemVat(item),
  };
  return strikePublicHt(resolved, null);
}

export function proUnitHt(resolved, catalogPriceTtc) {
  const vat = resolved?.vat_rate ?? 20;
  const rawTtc = resolved ? Number(resolved.price) : catalogPriceTtc != null ? Number(catalogPriceTtc) : null;
  if (rawTtc == null || Number.isNaN(rawTtc)) return null;
  if (resolved?.unit_price_ht != null && !Number.isNaN(Number(resolved.unit_price_ht))) {
    return Math.round(Number(resolved.unit_price_ht) * 100) / 100;
  }
  return ttcToHt(rawTtc, vat);
}
